export enum UserRoles {
  SUPERADMIN = 'superadmin',
  ADMIN = 'admin',
  CLIENTE = 'cliente',
  PACIENTE = 'paciente',
}
